import { CHOICES } from "../../utils/constants";

const Arena = ({ myChoice, oppChoice, revealed, myName, oppName }) => {
  return (
    <div className="arena">
      {/* My Side */}
      <div className={`arena-slot me-slot ${revealed ? "revealed" : ""}`}>
        {myChoice
          ? <span>{CHOICES[myChoice].emoji}</span>
          : <div className="hidden-placeholder">?</div>
        }
        <span className="slot-label">You</span>
      </div>

      <div className="arena-vs">VS</div>

      {/* Opponent Side */}
      <div className={`arena-slot opp-slot ${revealed ? "revealed" : ""}`}>
        {revealed && oppChoice
          ? <span>{CHOICES[oppChoice].emoji}</span>
          : oppChoice
            ? <span style={{ fontSize: 22 }}>✓</span>   // Chose but hidden
            : <div className="hidden-placeholder">?</div>
        }
        <span className="slot-label">{oppName || "Opp"}</span>
      </div>
    </div>
  );
};

export default Arena;